<template>
  <div>
    <basic-container>
      <video
        id="v"
        style="display:none"
        controls
        @canplaythrough="myFunction($event)"
      ></video>

      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @search-reset="searchClear"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleAdd()"
          >新增</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleStatus('上架')"
          >上架</el-button>
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleStatus('下架')"
          >下架</el-button>
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel()"
          >删除</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="downloadExcelVideo"
          >下载Excel</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="search"
        >
          <div style="display: flex;">
            <span style="line-height: 30px;margin-right:10px">视频投放地区</span>
            <div style="width:25%;margin-right:10px">
              <el-select
                v-model="currentProvince"
                size="small"
                @change="chooseProvince"
                placeholder="请选择省份"
              >
                <el-option
                  v-for="item in provinces"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div style="width:25%;margin-right:10px">
              <el-select
                v-model="currentCity"
                size="small"
                @change="chooseCity"
                placeholder="请选择城市"
              >
                <el-option
                  v-for="item in citys"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div style="width:25%;margin-right:10px">
              <el-select
                v-model="currentArea"
                size="small"
                @change="chooseArea"
                placeholder="请选择区/县"
              >
                <el-option
                  v-for="item in areas"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <template
          slot-scope="scope"
          slot="clientType"
        >
          <div>
            {{scope.row.clientType.split(",").map(item=>{
            if(item == "JOINS_USER"){
            item = '消费者'
            }else if(item == 'JOINS_ENGINEER'){
            item ='服务工程师'
            }else{
            item = '商户'
            }
            return item
            }).join(",")}}
          </div>
        </template>
        <template
          slot-scope="scope"
          slot="firstClassifyNameForm"
        >
          <el-select
            v-model="classify"
            placeholder="一级分类"
            required
            @change="chooseSecondClassify"
            value-key="id"
          >
            <el-option
              v-for="classify in classifies"
              :key="classify.id"
              :label="classify.name"
              :value="classify"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="secondClassifyNameForm"
        >
          <el-select
            v-model="secondClassify"
            placeholder="二级分类"
            required
            @change="findGoodslist"
            value-key="id"
          >
            <el-option
              v-for="secondClassify in secondClassifies"
              :key="secondClassify.id"
              :label="secondClassify.name"
              :value="secondClassify"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="goodsIdForm"
        >
          <el-select
            v-model="currentGood"
            placeholder="请选择商品"
            required
            @change="chooseGood"
            value-key="id"
          >
            <el-option
              v-for="currentGood in goods"
              :key="currentGood.id"
              :label="currentGood.goodsName"
              :value="currentGood"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="couponIdForm"
        >
          <el-select
            v-model="currentCoupon"
            placeholder="请选择商品优惠卷"
            value-key="id"
            multiple
            filterable
            required
            @change="chooseCoupon"
          >
            <el-option
              v-for="item in coupons"
              :key="item.id"
              :label="item.couponName"
              :value="item"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="clientTypeForm"
        >
          <el-select
            v-model="currclientType"
            multiple
            placeholder="请选择投放端口"
            @change="changeSendType"
          >
            <el-option
              v-for="item in clientTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="classifyForm"
        >
          <div>
            <el-select
              v-model="currClassify"
              id="checkLable"
              clearable
              multiple
              placeholder="选择标签"
              @change="changeTagsPeople(currClassify)"
            >
              <el-option
                v-for="item in classifySelects"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <div style="display: flex;flex-flow: row;justify-content: space-between;">
              <!-- <span style="color:#aaa">共{{totalPeople}}人</span> -->
              <a
                href="#/salesCloud/tags"
                style="text-decoration:none;color:#3085E6;"
              >管理标签</a>
            </div>
          </div>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="lookCoupons(scope.row)"
          >查看优惠卷</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menuBtn"
        >
          <el-button
            v-if="scope.row.status =='HIDE'"
            type="primary"
            size="small"
            plain
            @click.stop="handleStatus('上架',scope.row)"
          >上架</el-button>
          <el-button
            type="danger"
            v-if="scope.row.status =='NORMAL'"
            size="small"
            plain
            @click.stop="handleStatus('下架',scope.row)"
          >下架</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            v-if="scope.row.status !='ILLEGAL'"
            @click.stop="handleEdit(scope.row, scope.index)"
          >编辑</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            v-if="scope.row.status !='ILLEGAL'"
            @click.stop="handleDownloadVideo(scope.row)"
          >预览下载</el-button>
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row)"
          >删除</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="cover"
        >
          <viewer :images="formmaterImage(scope.row.cover)">
            <img
              v-for="src in formmaterImage(scope.row.cover)"
              :src="src"
              :key="src"
              width="40"
              @click.stop="createdVideo(scope.row)"
            />
          </viewer>
        </template>
        <template
          slot-scope="scope"
          slot="vodIdForm"
        >
          <!-- <form action>
            <input type="file" name="file" id="files" multiple />
          </form>-->
          <form
            action
            name="videoForm"
            id="videoForm"
            enctype="multipart/form-data"
          >
            <div v-if="videoUpdate">
              <!-- <div> -->
              <div class="dialog_container">
                <!-- <div class="el-progress-bar">
                  <div class="el-progress-bar__outer" style="height: 6px;">
                    <div class="el-progress-bar__inner" :style="{width:authProgress+'%'}"></div>
                  </div>
                </div>  -->
                <!-- <div
                  class="el-progress__text"
                  style="font-size: 14.4px;color:#40fffa"
                >{{authProgress}}%</div> -->
                <el-progress
                  type="circle"
                  :percentage="authProgress"
                ></el-progress>
              </div>
              <div class="spice_blank_opacity"></div>
            </div>
            <input
              type="file"
              id="fileUpload"
              name="fileUpload"
              accept="video/*, audio/*"
              ref="videoLength"
              multiple
              :disabled="fileUpload"
              @change="fileChange($event)"
            />
            <el-button
              size="mini"
              style="margin-left:5px;position:relative;top:-2px"
              @click.stop="checkDuration"
            >开始上传</el-button>
            <label class="status">
              <p>
                <span>上传状态:</span>
                <span>{{statusText}}</span>
                <span style="margin:0 20px;"></span>
                <span>上传进度:</span>
                <i id="auth-progress">{{authProgress}}</i> %
              </p>

              <p>
                <i style="color:#FF0000">为了提供给用户良好的观看体验，请上传10分钟以内的视频文件，严禁上传色情,淫秽,反动和其它违法内容。</i>
              </p>
            </label>
          </form>
        </template>
      </avue-crud>

      <el-dialog
        :visible.sync="centerDialogVisible"
        :close-on-click-modal="true"
        :destroy-on-close="false"
        :width="width"
        :show-close="false"
        center
        id="dialogIphone6"
      >
        <div v-if="centerDialogVisible">
          <img
            v-if="phoneBox=='iphone'"
            id="iphone6"
            src="../../../../../public/img/bg/iphone6.png"
            alt
          />
          <img
            v-if="phoneBox=='huawei'"
            id="huawei"
            src="../../../../../public/img/bg/huaweip6.png"
            alt
          />
          <img
            v-if="phoneBox=='iphonex'"
            id="iphonex"
            src="../../../../../public/img/bg/iphonex.png"
            alt
          />

          <div
            v-if="changeKeKe"
            class="prism-player"
            id="player-con"
          ></div>
        </div>
        <div style="display: flex;flex-flow: column;float: left;width: 103px;position: absolute;left: -124px;top:8px">
          <el-tooltip
            class="item"
            effect="dark"
            placement="left-start"
          >
            <div slot="content">
              iPhone6以.上(不包括SE,
              <br />X，XS，XS max, XR)等
              <br />长宽16:9的常见机型。
            </div>
            <el-button @click="normalPing">常规屏</el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            placement="left"
            style="margin:10px 0"
          >
            <div slot="content">
              华为荣耀6、OPPO R11s、
              <br />vivo X20等长宽16:9的带虚
              <br />拟键机型。
            </div>
            <el-button @click="shortPing">短屏</el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            placement="left-end"
            style="margin:0"
          >
            <div slot="content">
              iPhone X、XR、XS、一加
              <br />6、小米8等全面屏机型。
            </div>
            <el-button @click="longPing">全面屏</el-button>
          </el-tooltip>
        </div>
      </el-dialog>
      <el-dialog
        title="绑定优惠卷名称"
        :visible.sync="lookCouponDialogVisible"
        width="20%"
        v-model="couponName"
        center
      >
        <div
          v-for="item in couponName"
          :key="item"
          :value="item"
          :label="item"
          style="text-align: center;margin-top: 10px;"
        >
          <el-tag type="danger">{{item}}</el-tag>
          <br />
        </div>

        <span
          slot="footer"
          class="dialog-footer"
        >
          <!-- <el-button
            type="primary"
            @click="lookCouponDialogVisible = false"
          >关闭</el-button>-->
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script type="text/javascript" charset="utf-8" src="https://g.alicdn.com/de/prismplayer/2.8.7/aliplayer-min.js"></script>
<script>
import axios from "axios";
// import { createUploader } from "@/util/createUploader";
import { baseUrl } from "@/config/env";
import { DIC } from "@/const/dic";
import { excelaxios } from "@/util/excelaxios";
import { videosOption } from "@/const/salesCloud/videosOption";
import { skinLayoutOption } from "@/const/salesCloud/skinLayoutOption";
import { skinLayoutXOption } from "@/const/salesCloud/skinLayoutXOption";
import { skinLayoutHWOption } from "@/const/salesCloud/skinLayoutHWOption";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { exportExcel } from "xlsx-oc";
import { findLabelList } from "@/api/salesCloud/mobileRedPacket";
import {
  findVideosList,
  getAliyunVideoId,
  checkVideoLength,
  isShowVideo,
  findClassify,
  findCouponlist,
  downloadVideo,
  chooseSecondClassify,
  findGoodslist,
  addVideo,
  editVideo,
  delVideo,
  findProvince,
  findCitys,
  findAreas,
  findVideosListDownloadExcel,
} from "@/api/salesCloud/videos";

export default {
  name: "videos",
  components: {},
  data() {
    return {
      tableOption: videosOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      centerDialogVisible: false,
      lookCouponDialogVisible: false,
      couponName: [],
      videoUpdate: false,
      skinLayoutOption: skinLayoutOption,
      videoOption: skinLayoutOption,
      userData: "",
      clientTypes: DIC.WALLET_USER_TYPE,
      currclientType: "",
      classifySelects: [],
      currClassify: [],
      classifies: [],
      classify: {},
      provinces: [],
      currentProvince: {},
      citys: [],
      currentCity: {},
      areas: [],
      currentArea: {},
      goods: [],
      lineRow: {},
      currentGood: {},
      coupons: [],
      changeKeKe: true,
      currentCoupon: [],
      secondClassifies: [],
      secondClassify: {},
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      videoDuration: 0,
      width: "278px",
      phoneBox: "iphone",
      timeout: "",
      partSize: "",
      parallel: "",
      retryCount: "",
      retryDuration: "",
      region: "cn-shanghai",
      userId: "1303984639806000",
      file: null,
      videoId: "",
      authProgress: 0,
      totalPeople: 0,
      newarr1: [], //工程师
      newarr2: [], //商户
      fileUpload: false,
      uploadDisabled: true,
      resumeDisabled: true,
      pauseDisabled: true,
      uploader: null,
      merchants: [],
      engineers: [],
      player: null,
      videoUrl: "",
      statusText: "等待上传",
      grade: {
        box: false,
        check: [],
      },
    };
  },
  created() {
    findClassify().then((res) => {
      let data = JSON.parse(res.data);
      console.log("classifies", res);
      this.classifies = data;
    });
    findCouponlist().then((res) => {
      let data = JSON.parse(res.data);
      console.log("coupons", data);
      this.coupons = data.rows;
    });
    findProvince().then((res) => {
      // let data = JSON.parse(res.data);
      console.log(res);
      this.provinces = res.data;
      this.currentProvince = "";
      this.currentCity = "";
      this.currentArea = "";
    });
    let params = {
      clientType: "JOINS_MERCHANT",
    };
    findLabelList(params).then((res) => {
      let data = JSON.parse(res.data);
      this.merchants = data.list;
    });
    let newparams = {
      clientType: "JOINS_ENGINEER",
    };
    findLabelList(newparams).then((res) => {
      let data = JSON.parse(res.data);
      this.engineers = data.list;
    });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {},
  props: [],
  methods: {
    changeTagsPeople(currClassify) {
      let arr1 = this.engineers.map((item) => {
        return item.id;
      });
      let arr2 = this.merchants.map((item) => {
        return item.id;
      });
      let arr3 = [...currClassify];

      let newarr1 = [];
      let newarr2 = [];
      arr3.forEach((item) => {
        if (arr1.includes(item)) {
          newarr1.push(item);
        } else {
          newarr2.push(item);
        }
      });
      this.newarr1 = newarr1;
      this.newarr2 = newarr2;
    },
    changeSendType() {
      this.currClassify = [];
      // this.redpacketform = {};
      let params = {
        clientType: this.currclientType,
      };
      findLabelList(params).then((res) => {
        let data = JSON.parse(res.data);
        data = data.list.map((item) => {
          item.name = item.name + "(" + item.count + ")";
          return item;
        });
        this.classifySelects = data;
      });
    },
    lookCoupons(row) {
      if (row.couponName) {
        var a = row.couponName.split(",");
      } else {
        this.$message({
          showClose: true,
          type: "error",
          message: "该商品暂未绑定优惠卷",
          duration: 1000,
        });
        return;
      }
      this.couponName = a;
      this.lookCouponDialogVisible = true;
    },
    checkDuration() {
      if (this.videoDuration > 600) {
        console.log("超长10分钟");
        this.$message({
          showClose: true,
          message: "上传视频不能超过10分钟",
          type: "error",
        });
        return;
      }
      //传到阿里云
      var Title = this.file.name;
      var userData = '{"Vod":{}}';
      if (this.uploader) {
        this.uploader.stopUpload();
        this.authProgress = 0;
        this.statusText = "";
        console.log("存在", this.uploader);
      }
      let self = this;
      this.uploader = this.createUploader();
      console.log(this.uploader);
      console.log(userData);
      this.uploader.addFile(this.file, null, null, null, userData);
      this.uploadDisabled = false;
      this.pauseDisabled = true;
      this.resumeDisabled = true;
      if (this.uploader !== null) {
        this.uploader.startUpload();
        // this.fileUpload = true;//选择文件只选择一次
        this.videoUpdate = true;
        console.log("开始上传148");
      }
    },
    myFunction(ele) {
      console.log(ele.srcElement.duration);
      this.videoDuration = ele.srcElement.duration;
    },
    setVideoSrc(f) {
      var timer,
        tryTime,
        maxTry = 5,
        delay = 500;
      console.log(f);
      var url = URL.createObjectURL(f.target.files[0]);
      v.src = url;
      console.log(v);
      tryTime = 0;
    },
    longPing() {
      this.phoneBox = "iphonex";
      this.width = "278px";
      let row = this.lineRow;
      this.changeKeKe = false;
      console.log(row);
      this.videoOption = skinLayoutXOption;
      console.log(this.skinLayoutXOption);
      // this.skinLayoutXOption.height = "520px";
      this.$nextTick(() => {
        this.changeKeKe = true;
        this.changeVideo(row);
      });
    },
    normalPing() {
      this.phoneBox = "iphone";
      this.width = "278px";
      let row = this.lineRow;
      this.changeKeKe = false;
      this.videoOption = skinLayoutOption;
      this.$nextTick(() => {
        this.changeKeKe = true;
        this.changeVideo(row);
      });
    },
    shortPing() {
      this.phoneBox = "huawei";
      this.width = "278px";
      let row = this.lineRow;
      this.changeKeKe = false;
      this.videoOption = skinLayoutHWOption;
      this.$nextTick(() => {
        this.changeKeKe = true;
        this.changeVideo(row);
      });
    },
    chooseProvince() {
      console.log(this.currentProvince);
      findCitys(this.currentProvince).then((res) => {
        console.log(res);
        this.citys = res.data;
        this.currentCity = "";
        this.currentArea = "";
      });
    },
    chooseCity() {
      findAreas(this.currentCity).then((res) => {
        console.log(res);
        this.areas = res.data;
        this.currentArea = "";
      });
    },
    chooseArea() {
      console.log(this.currentArea);
    },
    chooseCoupon() {
      console.log(this);
    },
    chooseSecondClassify() {
      this.secondClassifies = [];
      this.secondClassify = {};
      this.goods = [];
      this.currentGood = {};
      chooseSecondClassify(this.classify.id).then((res) => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
        console.log(this);
      });
    },
    findGoodslist() {
      console.log(this);
      this.goods = [];
      this.currentGood = {};
      let params = {};
      params.type = "SELL";
      params.firstClassifyId = this.classify.id;
      params.secondClassifyId = this.secondClassify.id;
      findGoodslist(params).then((res) => {
        let data = JSON.parse(res.data);
        this.goods = data;
      });
    },
    chooseGood() {
      console.log(this);
    },
    searchClear() {
      console.log(this);
      this.currentProvince = "";
      this.currentCity = "";
      this.currentArea = "";
      this.citys = [];
      this.areas = [];
    },
    handleStatus(status, row) {
      console.log(status);
      let ids = null;
      if (!row) {
        ids = this.$refs.crud.tableSelect.map((item) => {
          return item.id;
        });
        let isBad = this.$refs.crud.tableSelect.some((item) => {
          if (item.status == "NORMAL" || item.status == "HIDE") {
            return true;
          } else {
            return false;
          }
        });
        console.log(isBad);
        if (!isBad) {
          this.$message({
            showClose: true,
            message: "视频状态异常",
            type: "error",
          });
          return;
        }
      } else {
        ids = row.id;
      }
      console.log(ids);
      if (ids == "") {
        this.$message({
          showClose: true,
          message: "请选择要操作数据",
          type: "error",
        });
        return;
      }
      if (status == "上架") {
        let params = {
          status: "NORMAL",
        };
        this.$confirm(`是否确认上架?`, "提示", {
          confirmButtonText: "上架",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            isShowVideo(ids, params).then((res) => {
              let data = JSON.parse(res.data);
              console.log(data);
              if (data.status == "200") {
                this.$message({
                  showClose: true,
                  message: "视频上架成功",
                  type: "success",
                });
                this.handleList();
              } else if (data.status == "205") {
                this.$message({
                  showClose: true,
                  message: "部分上架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: "视频状态异常",
                  type: "error",
                });
                this.handleList();
              }
            });
          })
          .catch(() => {});
      }
      if (status == "下架") {
        let params = {
          status: "HIDE",
        };
        this.$confirm(`是否确认下架?`, "提示", {
          confirmButtonText: "下架",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            isShowVideo(ids, params).then((res) => {
              console.log(res);
              let data = JSON.parse(res.data);
              console.log(data);
              if (data.status == "200") {
                this.$message({
                  showClose: true,
                  message: "视频下架成功",
                  type: "success",
                });
                this.handleList();
              } else if (data.status == "205") {
                this.$message({
                  showClose: true,
                  message: "部分下架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: "视频状态异常",
                  type: "error",
                });
                this.handleList();
              }
            });
          })
          .catch(() => {});
      }
    },
    fileChange(e) {
      this.file = e.target.files[0];
      this.setVideoSrc(e);
    },
    createUploader(type) {
      let self = this;
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = "添加文件成功, 等待上传...";
          console.log("addFileSuccess: " + uploadInfo.file.name);
          console.log("167uploadInfo", uploadInfo);
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          console.log("开始上传170", uploadInfo);
          // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
          // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
          // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
          if (!uploadInfo.videoId) {
            let params = {};
            params.title = self.file.name;
            console.log(self.file);
            params.fileName = self.file.name;
            getAliyunVideoId(params).then((res) => {
              console.log(res);
              let data = JSON.parse(res.data);
              console.log(data);
              console.log(uploadInfo);
              let uploadAuth = data.UploadAuth;
              let uploadAddress = data.UploadAddress;
              let videoId = data.VideoId;
              console.log(self);
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
            // let createUrl =
            //   "http://192.168.3.100:5200//joins-oss/v1/aliyun-vod/aliyunVod?title=test1&fileName=sss.mp4";
            // axios.get(createUrl).then(({ data }) => {
            //   let uploadAuth = data.UploadAuth;
            //   let uploadAddress = data.UploadAddress;
            //   let videoId = data.VideoId;
            //   uploader.setUploadAuthAndAddress(
            //     uploadInfo,
            //     uploadAuth,
            //     uploadAddress,
            //     videoId
            //   );
            // });
            self.statusText = "文件开始上传...";
            console.log(
              "onUploadStarted:" +
                uploadInfo.file.name +
                ", endpoint:" +
                uploadInfo.endpoint +
                ", bucket:" +
                uploadInfo.bucket +
                ", object:" +
                uploadInfo.object
            );
          } else {
            console.log("videoId有值");
            //自定义开始上传,需要改成断点续传
            let params = {};
            params.title = self.file.name;
            console.log(self.file);
            params.fileName = self.file.name;
            getAliyunVideoId(params).then((res) => {
              console.log(res);
              let data = JSON.parse(res.data);
              console.log(data);
              console.log(uploadInfo);
              let uploadAuth = data.UploadAuth;
              let uploadAddress = data.UploadAddress;
              let videoId = data.VideoId;

              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
            // 如果videoId有值，根据videoId刷新上传凭证
            // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            // let refreshUrl =
            //   "http://192.168.3.100:5200//joins-oss/v1/aliyun-vod/aliyunVod?title=test1&fileName=sss.mp4" +
            //   uploadInfo.videoId;
            // axios.get(refreshUrl).then(({ data }) => {
            //   let uploadAuth = data.UploadAuth;
            //   let uploadAddress = data.UploadAddress;
            //   let videoId = data.VideoId;
            //   uploader.setUploadAuthAndAddress(
            //     uploadInfo,
            //     uploadAuth,
            //     uploadAddress,
            //     videoId
            //   );
            // });
          }
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          console.log(
            "onUploadSucceed: " +
              uploadInfo.file.name +
              ", endpoint:" +
              uploadInfo.endpoint +
              ", bucket:" +
              uploadInfo.bucket +
              ", object:" +
              uploadInfo.object
          );
          console.log(uploadInfo);
          console.log(this);
          console.log(self);
          self.videoId = uploadInfo.videoId; //视频id

          self.statusText = "文件上传成功!";
          self.videoUpdate = false;
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          console.log(
            "onUploadFailed: file:" +
              uploadInfo.file.name +
              ",code:" +
              code +
              ", message:" +
              message
          );
          self.statusText = "文件上传失败!";
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
          console.log(
            "Canceled file: " +
              uploadInfo.file.name +
              ", code: " +
              code +
              ", message:" +
              message
          );
          self.statusText = "文件已暂停上传";
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          console.log(
            "onUploadProgress:file:" +
              uploadInfo.file.name +
              ", fileSize:" +
              totalSize +
              ", percent:" +
              Math.ceil(progress * 100) +
              "%"
          );
          let progressPercent = Math.ceil(progress * 100);
          self.authProgress = progressPercent;
          self.statusText = "文件上传中...";
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          //自定义开始上传,需要改成超时上传
          let params = {};
          params.title = self.file.name;
          console.log(self.file);
          params.fileName = self.file.name;
          getAliyunVideoId(params).then((res) => {
            console.log(res);
            let data = JSON.parse(res.data);
            console.log(data);
            console.log(uploadInfo);
            let uploadAuth = data.UploadAuth;
            let uploadAddress = data.UploadAddress;
            let videoId = data.VideoId;
            uploader.setUploadAuthAndAddress(
              uploadInfo,
              uploadAuth,
              uploadAddress,
              videoId
            );
          });
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
          // let refreshUrl =
          //   "https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=" +
          //   uploadInfo.videoId;
          // axios.get(refreshUrl).then(({ data }) => {
          //   let uploadAuth = data.UploadAuth;
          //   uploader.resumeUploadWithAuth(uploadAuth);
          //   console.log(
          //     "upload expired and resume upload with uploadauth " + uploadAuth
          //   );
          // });
          self.statusText = "文件超时...";
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          console.log("onUploadEnd: uploaded all the files");
          self.statusText = "文件上传完毕";
        },
      });
      return uploader;
    },
    createdVideo(row) {
      // videoUrl
      console.log(row);
      // v-if="scope.row.status !='ILLEGAL'"
      if (row.status == "ILLEGAL") {
        this.$message({
          showClose: true,
          message: "违规删除",
          type: "error",
        });
        return;
      }
      this.lineRow = row;
      if (this.videoUrl != "") {
        console.log("销毁上一个视频");
        this.player.dispose();
      }
      this.centerDialogVisible = true;
      this.phoneBox = "iphone";
      this.videoUrl = row.videoUrl;
      // "https://outin-c614e38f255f11eabcf000163e1c7426.oss-cn-shanghai.aliyuncs.com/a33cd75b32734bdebef61b1803066833/d74a31d5d860433d8a200474b91bd262-d94f2fb93e3e859ac7c54a08524c640f-fd.mp4?Expires=1577263446&OSSAccessKeyId=LTAI3DkxtsbUyNYV&Signature=k%2B%2F17FGYDlS3%2BPMlzbFJBMNjJLw%3D";
      // "https://mp4.vjshi.com/2019-09-05/968c95913999985939c828f77b118a0f.mp4";
      ("//player.alicdn.com/video/aliyunmedia.mp4");
      this.skinLayoutOption.source = this.videoUrl;
      this.$nextTick(() => {
        var player = new Aliplayer(this.skinLayoutOption, function (player) {
          console.log("The player is created");
        });
        this.player = player;
        console.log(this);
      });
    },
    changeVideo(row) {
      // videoUrl
      console.log(row);
      if (this.videoUrl != "") {
        console.log("销毁上一个视频");
        this.player.dispose();
      }
      this.centerDialogVisible = true;
      this.videoUrl = row.videoUrl;
      // "https://outin-c614e38f255f11eabcf000163e1c7426.oss-cn-shanghai.aliyuncs.com/a33cd75b32734bdebef61b1803066833/d74a31d5d860433d8a200474b91bd262-d94f2fb93e3e859ac7c54a08524c640f-fd.mp4?Expires=1577263446&OSSAccessKeyId=LTAI3DkxtsbUyNYV&Signature=k%2B%2F17FGYDlS3%2BPMlzbFJBMNjJLw%3D";
      // "https://mp4.vjshi.com/2019-09-05/968c95913999985939c828f77b118a0f.mp4";
      ("//player.alicdn.com/video/aliyunmedia.mp4");
      this.videoOption.source = this.videoUrl;
      console.log(this.videoOption);
      this.$nextTick(() => {
        var player = new Aliplayer(this.videoOption, function (player) {
          console.log("The player is change");
        });
        this.player = player;
        console.log(this);
      });
    },
    // beforeClose() {
    //   console.log("done");
    //   if (this.videoUrl != "") {
    //     console.log("销毁上一个视频");
    //     this.player.dispose();
    //   }
    // },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      params.requestType = "LIST";
      this.downloadData = params;
      findVideosList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      params.requestType = "LIST";
      this.downloadData = params;
      findVideosList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.requestType = "LIST";
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.createTimeStart = params.startDate_endDate[0];
        params.createTimeEnd = params.startDate_endDate[1];
      } else {
        delete params.createTimeStart;
        delete params.createTimeEnd;
      }
      params.province = this.currentProvince;
      params.city = this.currentCity;
      params.area = this.currentArea;
      this.downloadData = params;
      findVideosList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      params.requestType = "LIST";
      this.downloadData = params;
      findVideosList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    clean() {
      this.statusText = "等待上传";
      this.authProgress = 0;
      this.secondClassifies = [];
      this.secondClassify = {};
      this.classify = {};
      this.currClassify = [];
      this.currclientType = [];
      this.currentGood = {};
      this.goods = [];
      this.videoId = "";
      this.currentCoupon = [];
    },
    handleAdd() {
      this.clean();
      this.file = null;
      var file = document.getElementById("fileUpload");
      // for IE, Opera, Safari, Chrome
      // FF(包括3.5)
      if (file) {
        file.value = "";
      }
      this.fileUpload = false;
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      console.log(row, index);
      this.clean();
      //投放端口回显
      if (row.clientType.length < 4) {
        console.log(row.clientType);
        this.currclientType = row.clientType;
      } else {
        console.log(row.clientType.length);
        this.currclientType.push(row.clientType);
      }
      if (this.currclientType.includes("JOINS_MERCHANT")) {
        let newparams1 = {
          clientType: "JOINS_MERCHANT",
        };
        findLabelList(newparams1).then((res) => {
          let data = JSON.parse(res.data);
          data = data.list.map((item) => {
            item.name = item.name + "(" + item.count + ")";
            return item;
          });
          this.classifySelects = data;
          console.log(this.classifySelects);
        });
      }
      if (this.currclientType.includes("JOINS_ENGINEER")) {
        let newparams2 = {
          clientType: "JOINS_ENGINEER",
        };
        findLabelList(newparams2).then((res) => {
          let data = JSON.parse(res.data);
          data = data.list.map((item) => {
            item.name = item.name + "(" + item.count + ")";
            return item;
          });
          this.classifySelects.push(...data);
          console.log(this.classifySelects);
        });
      }

      // this.classify = row.
      //优惠卷回显
      if (row.couponId) {
        let a = [];
        row.couponId.split(",").map((item, i) => {
          return (a[i] = { id: item });
        });
        this.currentCoupon = a;
      }
      //一级分类回显
      this.classify.id = row.firstClassifyId;
      chooseSecondClassify(this.classify.id).then((res) => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
        console.log(this);
      });
      //二级分类回显
      this.secondClassify.id = row.secondClassifyId;
      let params = {};
      params.firstClassifyId = this.classify.id;
      params.secondClassifyId = this.secondClassify.id;
      findGoodslist(params).then((res) => {
        let data = JSON.parse(res.data);
        this.goods = data;
      });
      //商品回显
      this.currentGood.id = row.goodsId;

      //标签回显
      let labels = [];
      row.labels.map((item) => {
        labels.push(...item.labelIds.split(","));
        return labels;
      });
      this.currClassify = labels;
      this.fileUpload = false;
      this.$refs.crud.rowEdit(row, index);
    },
    formmaterImage(row) {
      let str = new Array();
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
        requestType: "LIST",
      };
      this.downloadData = params;

      findVideosList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      // this.uploader.startUpload(); //点击新增后上传
      console.log(row);
      console.log(this.videoId);
      let params = {};
      if (row.province) {
        params.province = row.province;
      }
      if (row.city) {
        params.city = row.city;
      }
      if (row.area) {
        params.area = row.area;
      }
      params.clientType = this.currclientType.join(",");
      let labels = [];
      if (this.currClassify.length != 0) {
        if (this.newarr1.length > 0) {
          let engineer = {
            clientType: "JOINS_ENGINEER",
            labelIds: this.newarr1.join(","),
          };
          labels.push(engineer);
        }
        if (this.newarr2.length > 0) {
          let merchant = {
            clientType: "JOINS_MERCHANT",
            labelIds: this.newarr2.join(","),
          };
          labels.push(merchant);
        }
      } else {
      }
      params.labels = labels;
      params.name = row.name;
      params.firstClassifyId = this.classify.id;
      params.secondClassifyId = this.secondClassify.id;
      params.goodsId = this.currentGood.id;
      let couponId = [];
      this.currentCoupon.map((item) => {
        couponId.push(item.id);
        return couponId;
      });
      couponId = couponId.join(",");
      console.log(couponId);
      console.log(params);
      if (couponId) {
        params.couponId = couponId;
      }
      if (this.videoId) {
        params.vodId = this.videoId;
      } else {
        this.$message({
          showClose: true,
          message: "视频上传失败",
          type: "error",
        });
        done();
        return;
      }
      console.log(params);
      addVideo(params).then((res) => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row, label) {
      let ids = null;
      if (!row) {
        ids = this.$refs.crud.tableSelect.map((item) => {
          return item.id;
        });
      } else {
        ids = row.id;
      }
      console.log(ids);
      if (ids == "") {
        this.$message({
          showClose: true,
          message: "请选择要操作数据",
          type: "error",
        });
        return;
      }
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delVideo(ids).then((res) => {
            console.log(res);
            this.$message({
              showClose: true,
              message: "视频删除成功",
              type: "success",
            });
            this.handleList();
          });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row, index);
      let params = {};
      params.id = row.id;
      params.name = row.name;
      if (row.province) {
        params.province = row.province;
      } else {
        params.province = "";
      }
      if (row.city) {
        params.city = row.city;
      } else {
        params.city = "";
      }
      if (row.area) {
        params.area = row.area;
      } else {
        params.area = "";
      }
      params.clientType = this.currclientType.join(",");
      let labels = [];
      if (this.currClassify.length != 0) {
        if (this.newarr1.length > 0) {
          let engineer = {
            clientType: "JOINS_ENGINEER",
            labelIds: this.newarr1.join(","),
          };
          labels.push(engineer);
        }
        if (this.newarr2.length > 0) {
          let merchant = {
            clientType: "JOINS_MERCHANT",
            labelIds: this.newarr2.join(","),
          };
          labels.push(merchant);
        }
      } else {
      }
      params.labels = labels;
      params.goodsId = this.currentGood.id ? this.currentGood.id : "";
      params.firstClassifyId = this.classify.id ? this.classify.id : "";
      params.secondClassifyId = this.secondClassify.id
        ? this.secondClassify.id
        : "";
      let couponId = [];
      this.currentCoupon.map((item) => {
        couponId.push(item.id);
        return couponId;
      });
      couponId = couponId.join(",");

      if (couponId) {
        params.couponId = couponId;
      }
      if (this.videoId) {
        params.vodId = this.videoId;
      } else {
        params.vodId = row.vodId;
      }
      console.log(params);
      editVideo(params).then((res) => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
      done();
    },
    handleDownloadVideo(row) {
      console.log(row);
      window.open(row.videoUrl);

      // 后端下载
      // let id = row.id;
      // downloadVideo(id).then(res => {
      //   console.log(res);
      // });
    },
    downloadExcelVideo() {
      let params = this.downloadData;
      // let url = `/joins-home/v1/video/excel?`;
      // excelaxios(url, params);
      findVideosListDownloadExcel(params).then((res) => {
        window.open(res);
      });
    },
  },
};
</script>

<style lang="scss">
.dialog_container {
  overflow: hidden;
  position: fixed;
  top: 43%;
  left: 0%;
  width: 100%;
  height: 100%;
  text-align: center !important;
  z-index: 300000000;
  // background: #fff;
}
.el-progress__text {
  font-size: 36px !important;
  color: #20a0ff;
}
.spice_blank_opacity {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: black;
  z-index: 999999;
  opacity: 0.6 !important;
}
#iphone6 {
  position: relative;
  top: -80px;
  left: -27px;
  float: left;
  width: 283px;
  height: 580px;
}
#huawei {
  position: relative;
  top: -76px;
  left: -27px;
  float: left;
  width: 282px;
  height: 570px;
}
#iphonex {
  position: relative;
  top: -63px;
  left: -28px;
  float: left;
  width: 283px;
  height: 582px;
}
#dialogIphone6 {
  .el-dialog {
    .el-dialog__body {
      background: black;
    }
    .el-dialog__header {
      padding: 0px !important;
    }
  }
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
#fileUpload {
  background: #99a9bf;
}
</style>
